import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group.jsx";
import { Label } from "@/components/ui/label.jsx";
import { router } from "@inertiajs/react";

const sortingVariants = [
  {
    name: "Наш выбор",
    value: "default",
  },
  {
    name: "По названию (а-я)",
    value: "name-a-z",
  },
  {
    name: "По названию (я-а)",
    value: "name-z-a",
  },
  {
    name: "Сначала новые",
    value: "newest-first",
  },
  {
    name: "Сначала старые",
    value: "oldest-first",
  },
  {
    name: "По цене (сначала дороже)",
    value: "price-high-to-low",
  },
  {
    name: "По цене (сначала дешевле)",
    value: "price-low-to-high",
  },
  // {
  //   name: "Популярные",
  //   value: "best-selling",
  // },
];

export default function () {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const sortBy = params.get("sort_by");

  const handleChange = (v) => {

    params.set('sort_by', v);
    router.visit(`?${params.toString()}`)
  }

  return (
    <div>
      <RadioGroup defaultValue="comfortable" onValueChange={handleChange}>
        {sortingVariants.map((sv) => {
          return (
            <div className="flex items-center gap-3">
              <RadioGroupItem value={sv.value} id={sv.value} checked={sv.value === sortBy} />
              <Label htmlFor={sv.value}>{sv.name}</Label>
            </div>
          );
        })}
      </RadioGroup>
    </div>
  );
}
